import { Club } from '@hefe/models';
import { Button, Space } from 'antd';
import { useAppDispatch } from '../../../../store/store';
import { t } from '@hefe/i18n';
import React, { useState } from 'react';
import EditorComponent from '../../../core/components/editor/editor.component';
import { ClubSlice, ModalsSlice } from '@hefe/store';
import WelcomePage from '../../../../views/base/welcome/welcome.page';

interface ClubWelcomeTextComponentProps {
  club: Club;
}

export default function ClubWelcomeTextComponent(
  props: ClubWelcomeTextComponentProps
) {
  const dispatch = useAppDispatch();
  const [text, setText] = useState(props.club.welcome_text ?? '');
  const [saving, setSaving] = useState(false);

  const updateWelcomeText = () => {
    setSaving(true);
    dispatch(
      ClubSlice.updateClubWelcomeText({
        welcome_text: text,
      })
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setSaving(false));
  };

  const openPreviewModal = () => {
    dispatch(
      ModalsSlice.modalsActions.openModal({
        component: <WelcomePage club={props.club} />,
        title: t('preview'),
        width: 1000,
        hideCancelButton: true,
        onOk: (closeModal) => {
          closeModal();
        },
      })
    );
  };

  return (
    <div>
      <EditorComponent
        defaultValue={text}
        value={text}
        style={{ minHeight: 350 }}
        onChange={(value) => setText(value)}
      />
      <Space>
        <Button
          type="primary"
          loading={saving}
          onClick={() => updateWelcomeText()}
        >
          {t('save')}
        </Button>
        <Button onClick={() => openPreviewModal()}>{t('preview')}</Button>
      </Space>
    </div>
  );
}
